import { Node } from "./node.tsx";
import { Fragment } from "react";
import {HistoryTreeData} from "shared/components/chatter/chatter.tsx";

interface HistoryTreeProps {
  data: HistoryTreeData[];
}
export const HistoryTree = ({data}:HistoryTreeProps) => {
  return (
    <div className='flex flex-col gap-5'>
      {data.map(node => (
        <Fragment key={node.id}>
          <Node {...node}/>
        </Fragment>
      ))}
    </div>
  );
};